<template>
  <div
    :id="`wrapper_${index}`"
    class="my-20"
  >
    <h2
      v-if="slice.primary.title"
      class="text-header2 md:text-desktop-header2"
    >
      {{ slice.primary.title }}
    </h2>
    <div
      v-for="(card, index) in slice.primary.cards"
      :key="index"
      class="card border-charcoal-25 xl:flex"
      :class="slice.primary.theme === 'Default' ? 'py-4 border-y border-collapse *:!pl-0' : [useTheme(slice.primary.theme), 'border my-4']"
    >
      <PrismicImage
        v-if="card.image.url"
        :field="card.image"
        class="xs:max-h-[500px] w-full object-cover object-top sm:max-h-[800px] md:order-last md:flex xl:w-[500px]"
      />

      <div class="p-10 md:flex-1">
        <h2 class="text-header3 md:text-desktop-header3">
          {{ card.title }}
        </h2>
        <h3
          v-if="card.sub_title"
          class="mt-4 text-header4 md:text-desktop-header4"
        >
          {{ card.sub_title }}
        </h3>
        <PrismicRichText
          :field="card.content"
          class="mt-10 text-body-copy md:pr-20 md:text-desktop-body-copy"
        />

        <UIButton
          v-if="prismic.asLink(card.link)"
          type="text"
          label="Find out more"
          :link="prismic.asLink(card.link)"
          class="mt-5"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const prismic = usePrismic();

gsap.registerPlugin(ScrollTrigger);

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.CardListSlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);

onMounted(() => {
  if (props.index != 0) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#wrapper_${props.index.toString()}`,
        start: "top 80%",
        end: "bottom bottom",
        scrub: true,
      },
    });

    tl.from(`#wrapper_${props.index.toString()} .card`, { y: "50px", opacity: 0, duration: 0.5, stagger: 0.2 });
  }
});
</script>
